import * as Types from 'app/types/schema';

import gql from 'graphql-tag';
import * as Urql from 'app/libs/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderRequestAgainQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.OrderRequestFilters>;
  sorts?: Types.InputMaybe<Array<Types.SortProps> | Types.SortProps>;
  limit?: Types.InputMaybe<Types.Scalars['Float']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type OrderRequestAgainQuery = { __typename?: 'Query', orderRequests: { __typename?: 'OrderRequestConnection', totalCount: number, edges?: Array<{ __typename?: 'OrderRequestEdge', node: { __typename?: 'OrderRequestSchema', parentTenantId?: string | null, childTenantId?: string | null, type?: Types.OrderRequestTypeEnum | null, orderRequestItems: Array<{ __typename?: 'OrderRequestItemSchema', id: string, imageUrl?: string | null, itemId?: string | null, description?: string | null, upcCode?: string | null, website?: string | null, status: Types.OrderRequestItemStatusEnum, type: Types.OrderRequestItemTypeEnum, quantity: number, projectId?: string | null, cost?: string | null, note?: string | null, itemIdInPartnerTenant?: string | null, project?: { __typename?: 'ProjectSchema', id: string, name: string } | null, nonRemovableNotes?: Array<{ __typename?: 'OrderRequestItemNonRemovableNoteSchema', estimatedDeliveryDate?: string | null, orderId?: string | null, vendor?: string | null }> | null, item?: { __typename?: 'AssetItemSchema', id: string, sku: string, title: string, pickableThroughOrderRequest?: boolean | null, categoryId: string, deletedAt?: string | null, status: Types.ItemStatusEnum, type: Types.ItemTypeEnum, entityIdInSourceTenant?: string | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'AssetKitItemSchema', id: string, sku: string, title: string, pickableThroughOrderRequest?: boolean | null, categoryId: string, deletedAt?: string | null, status: Types.ItemStatusEnum, type: Types.ItemTypeEnum, entityIdInSourceTenant?: string | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'AssetModelItemSchema' } | { __typename?: 'InventoryItemSchema', id: string, sku: string, title: string, pickableThroughOrderRequest?: boolean | null, categoryId: string, deletedAt?: string | null, status: Types.ItemStatusEnum, type: Types.ItemTypeEnum, entityIdInSourceTenant?: string | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'InventoryKitItemSchema', id: string, sku: string, title: string, pickableThroughOrderRequest?: boolean | null, categoryId: string, deletedAt?: string | null, status: Types.ItemStatusEnum, type: Types.ItemTypeEnum, entityIdInSourceTenant?: string | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | null }> } }> | null, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, nextCursor?: string | null, prevCursor?: string | null } | null } };


export const OrderRequestAgainDocument = gql`
    query orderRequestAgain($filters: OrderRequestFilters, $sorts: [SortProps!], $limit: Float, $after: String, $before: String) {
  orderRequests(
    filters: $filters
    sorts: $sorts
    limit: $limit
    after: $after
    before: $before
  ) {
    edges {
      node {
        orderRequestItems {
          id
          imageUrl
          itemId
          description
          upcCode
          website
          status
          type
          quantity
          projectId
          project {
            id
            name
          }
          cost
          nonRemovableNotes {
            estimatedDeliveryDate
            orderId
            vendor
          }
          note
          itemIdInPartnerTenant
          item {
            ... on AssetItemSchema {
              id
              sku
              title
              pickableThroughOrderRequest
              categoryId
              attachments {
                url
                mimeType
              }
              deletedAt
              status
              type
              entityIdInSourceTenant
            }
            ... on AssetKitItemSchema {
              id
              sku
              title
              pickableThroughOrderRequest
              categoryId
              attachments {
                url
                mimeType
              }
              deletedAt
              status
              type
              entityIdInSourceTenant
            }
            ... on InventoryItemSchema {
              id
              sku
              title
              pickableThroughOrderRequest
              categoryId
              attachments {
                url
                mimeType
              }
              deletedAt
              status
              type
              entityIdInSourceTenant
            }
            ... on InventoryKitItemSchema {
              id
              sku
              title
              pickableThroughOrderRequest
              categoryId
              attachments {
                url
                mimeType
              }
              deletedAt
              status
              type
              entityIdInSourceTenant
            }
          }
        }
        parentTenantId
        childTenantId
        type
      }
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
    }
    totalCount
  }
}
    `;

export function useOrderRequestAgainQuery(options?: Omit<Urql.UseQueryArgs<OrderRequestAgainQueryVariables>, 'query'>) {
  return Urql.useQuery<OrderRequestAgainQuery>({ query: OrderRequestAgainDocument, ...options });
};